var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92505 10.8662C6.16719 11.1084 6.16718 11.5079 5.92505 11.75C5.6829 11.9921 5.28341 11.9921 5.04126 11.75L0.69458 7.40332C0.317157 7.02577 0.125244 6.52689 0.125244 6.02832C0.125248 5.52975 0.317152 5.03087 0.69458 4.65332L5.04126 0.306641C5.28341 0.0644917 5.6829 0.0644917 5.92505 0.306641C6.1672 0.54879 6.1672 0.948281 5.92505 1.19043L1.57837 5.53711C1.30747 5.80824 1.30748 6.2484 1.57837 6.51953L5.92505 10.8662Z",
    fill: "#6D6D6D",
    stroke: "#6D6D6D",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.c731de840b782399fe0bba4b84f96f0c.svg";
export { ForwardRef as ReactComponent };